import React from "react";
import ReactDOM from "react-dom/client";
import "./styles.css";
import { App } from "./App";
import { installPreloadErrorBanner } from "./preload-error-banner";

// Surface stale-chunk failures as a "tap to reload" banner instead of
// letting the user sit on a half-broken page when a deploy goes out
// mid-session. See preload-error-banner.ts for the why.
installPreloadErrorBanner();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
